export default "<img [src]=\"urlImage\" [ngStyle]=\"{'width': width}\"> ";